<div class="modal-header">
  <h5 class="modal-title">
    <i class="fal fa-file-alt"></i> Select Invoice Template
    <i
      matTooltip="Select invoice template you want to apply to a booking."
      matTooltipPosition="above"
      matTooltipClass="text-center"
      class="fal fa-question-circle"
    ></i>
  </h5>
  <button (click)="onClose()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" [formEditablePermission]="form" class="row">
    <div class="col-sm-8 offset-2">
      <app-select-search
        [items]="templates$ | async"
        bindValue="pkey"
        bindLabel="name"
        [ctrl]="form.get('template')"
        [multiple]="false"
        [hasBlank]="false"
        matTooltip="Click here to select the invoice template that will be applied to a booking."
        matTooltipPosition="above"
        matTooltipClass="text-center"
        placeholder="Invoice Template"
      >
        <ng-container class="error-container">
          <mat-error> Invoice Template is <strong>required</strong> </mat-error>
        </ng-container>
      </app-select-search>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="onClose()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i> cancel
  </button>
  <button (click)="onSave(form)" type="button" class="btn btn-success text-uppercase create-btn">
    <i class="fal fa-bolt"></i> apply
  </button>
</div>
